'use strict';

let formValidation = require('../components/formValidation');
let csrfToken = require('../components/csrfToken');
const recaptcha = require('core/components/recaptcha');
/* This var is used as workaround to prevent multiple submit in login page */
let divId = 'loginSubmitInProgress';

const isMargiela = document.body.dataset.sitebrand === "Margiela";

module.exports = {
  login: function () {
    $('form.login').on('bouncerFormValid', function (e) {
      e.preventDefault();

      let myEle = document.getElementById(divId);
      if (myEle) {
        return false;
      }

      /* workaround to prevent multiple submit in login page */
      let div = document.createElement('div');
      div.id = divId;
      document.body.appendChild(div);

      let form = $(this);
      e.preventDefault();
      let url = form.attr('action');
      $.spinner().start();
      $('form.login').trigger('login:submit', e);
      csrfToken.refresh(form).then(function () {
        $.ajax({
          url: url,
          type: 'post',
          dataType: 'json',
          data: form.serialize(),
          success: function (data) {
            $.spinner().stop();
            document.getElementById(divId).remove();
            if (!data.success && data.journeyMsg) {
              if (document.querySelectorAll('.journey-start.js_journey-start').length < 1) {
                const journeyAlert = $(data.journeyMsg);
                const alertDanger = form.find('.alert-danger');
                if (alertDanger.length > 0) {
                  journeyAlert.insertAfter(alertDanger);
                } else {
                  form.prepend(journeyAlert);
                }
              }
              $('form.login').trigger('login:error', data);
            } else if (!data.success) {
              formValidation(form, data);
              $.spinner().stop();
            } else {
              $('form.login').trigger('login:success', data);

              // Tealium event "When the user correctly login"
              $('body').trigger('user:loggedIn');
              location.href = data.redirectUrl;
            }
          },
          error: function (data) {
            document.getElementById(divId).remove();
            if (data.responseJSON && data.responseJSON.redirectUrl) {
              window.location.href = data.responseJSON.redirectUrl;
            } else {
              $('form.login').trigger('login:error', data);
              $.spinner().stop();
            }
          },
        });
      });
      return false;
    });
  },

  guestlogin: function () {
    $('form.guest-login').on('bouncerFormValid', function (e) {
      e.preventDefault();

      let myEle = document.getElementById(divId);
      if (myEle) {
        return false;
      }

      /* workaround to prevent multiple submit in login page */
      let div = document.createElement('div');
      div.id = divId;
      document.body.appendChild(div);

      let form = $(this);
      e.preventDefault();
      let url = form.attr('action');
      $.spinner().start();
      $('form.guest-login').trigger('login:submit', e);
      $.ajax({
        url: url,
        type: 'post',
        dataType: 'json',
        data: form.serialize(),
        success: function (data) {
          $.spinner().stop();
          document.getElementById(divId).remove();
          if (!data.status) {
            formValidation(form, data);
          } else {
            location.href = data.redirectUrl;
          }
        },
        error: function (data) {
          document.getElementById(divId).remove();
          if (data.responseJSON && data.responseJSON.redirectUrl) {
            window.location.href = data.responseJSON.redirectUrl;
          } else {
            $('form.guest-login').trigger('login:error', data);
            $.spinner().stop();
          }
        },
      });
      return false;
    });
  },

  resetPassword: function () {
    $('.reset-password-form').off('bouncerFormValid');
    $('.reset-password-form').on('bouncerFormValid', function (e) {
      let form = $(this);
      e.preventDefault();
      $.spinner().start();
      $('.reset-password-form').trigger('login:register', e);

      var resetPasswordAjax = function (form) {
        let url = form.attr('action');
        $.ajax({
          url: url,
          type: 'post',
          dataType: 'json',
          data: form.serialize(),
          success: function (data) {
            $.spinner().stop();
            if (!data.success) {
              formValidation(form, data);
            } else {
              if (isMargiela) {
                $('#forgot-password #modal-forgot-password').addClass('d-none');
                $('#forgot-password #modal-forgot-password-confirm').removeClass('d-none');
                
                const triggerComp = $('#forgot-password').closest('[data-component="ModalTriggerComponent"]');
                if (triggerComp.length > 0 && form.closest('.modal.is-open').length === 0) {
                  triggerComp.trigger('click');
                }
              } else {
                document.getElementById('modal-forgot-password').style.display = 'none';
                document.getElementById('modal-forgot-password-confirm').style.display = 'block';
              }
            }
          },
          error: function () {
            $.spinner().stop();
          },
        });
      };

      if ($('.g-recaptcha').length > 0) {
        let siteKey = $('#recaptchaSitekey').length > 0 ? $('#recaptchaSitekey').val() : null;
        var $gRecaptchaElement = $('#gReCaptchaResetPassword').length ? $('#gReCaptchaResetPassword') : $('#gReCaptchaResetPasswordForgot');
        if ($gRecaptchaElement.length > 0 && siteKey) {
          recaptcha.loadReCaptcha(siteKey).then(function() {
            grecaptcha.ready(function() {
              grecaptcha.execute(siteKey, {action:'submit'}).then(function(token) {
                $gRecaptchaElement.val(token);
                resetPasswordAjax(form);
              });
            });
          });
        }
      } else {
        resetPasswordAjax(form);
      }
      return false;
    });
  },

  clearResetForm: function () {
    $('#login .modal').on('hidden.bs.modal', function () {
      $('#reset-password-email').val('');
      $('.modal-dialog .form-control.is-invalid').removeClass('is-invalid');
    });
  },

  changePassword: function () {
    $('.change-password-form').on('bouncerFormValid', function (e) {
      let form = $(this);
      e.preventDefault();
      let url = form.attr('action');
      $.spinner().start();
      $.ajax({
        url: url,
        type: 'post',
        dataType: 'json',
        data: form.serialize(),
        success: function (data) {
          $.spinner().stop();
          if (!data.success) {
            formValidation(form, data);
          } else {
            if (isMargiela) {
              document.getElementById('modal-new-password').classList.add('d-none');
              document.getElementById('modal-new-password-confirm').classList.remove('d-none');
            } else {
              document.getElementById('modal-new-password').style.display = 'none';
              document.getElementById('modal-new-password-confirm').style.display = 'block';
            }
          }
        },
        error: function () {
          $.spinner().stop();
        },
      });
      return false;
    });
  },
};
